import { render, staticRenderFns } from "./DSMarkedList.vue?vue&type=template&id=677fd6d7&scoped=true&"
import script from "./DSMarkedList.vue?vue&type=script&lang=js&"
export * from "./DSMarkedList.vue?vue&type=script&lang=js&"
import style0 from "./DSMarkedList.vue?vue&type=style&index=0&id=677fd6d7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "677fd6d7",
  null
  
)

export default component.exports